import { useEffect, useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import axios from "axios";
import BlogDetails from "../1_home2/BlogDetails";
import { useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../Admin_Pages/Admin_Layout/AdminLayout";

const CreateNews = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { update = false, formData = {} } = location.state || {};

  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [week, setWeek] = useState("");
  const [date, setDate] = useState("");
  const [field, setField] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [sections, setSections] = useState([]);

  useEffect(() => {
    if (update && formData) {
      setTitle(formData.title || "");
      setType(formData.type || "");
      setWeek(formData.week || "");
      setDate(formData.date || "");
      setField(formData.field || "");
      setImageURL(formData.imageURL || "");
      setShortDescription(formData.shortDescription || "");
      setSections(formData.sections || []);
    }
  }, [update, formData]);

  const addSection = () => {
    setSections([...sections, { header: "", content: "" }]);
  };

  const handleSectionChange = (index, field, value) => {
    const updated = [...sections];
    updated[index][field] = value;
    setSections(updated);
  };

  const removeSection = (index) => {
    const updated = sections.filter((_, i) => i !== index);
    setSections(updated);
  };

  const addLongDescription = () => {
    return sections
      .map((section) => `<h2>${section.header}</h2><p>${section.content}</p><br>`)
      .join("");
  };

  const handleSubmit = async () => {
    if (
      !title.trim() ||
      !type.trim() ||
      !week.trim() ||
      !date.trim() ||
      !field.trim() ||
      !imageURL.trim() ||
      !shortDescription.trim()
    ) {
      alert("Please fill all required fields.");
      return;
    }

    if (sections.length === 0) {
      alert("Please add at least one section.");
      return;
    }

    const longDescription = addLongDescription();

    const newsData = {
      title,
      type,
      week,
      date,
      field,
      imageURL,
      shortDescription,
      longDescription,
      sections,
    };

    try {
      const token = localStorage.getItem("token");
      if (update) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/news/${formData._id}`,
          newsData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        alert("News updated successfully!");
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/news`,
          newsData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        alert("News submitted successfully!");
      }

      navigate("/admin-dashboard/manage-blogs/update-news");
    } catch (error) {
      console.error("Error submitting news:", error);
      alert("Error creating news. Try again.");
    }
  };

  return (
    <AdminLayout role="user">
      <Container maxWidth="lg" sx={{ mt: 10 }}>
        <Typography variant="h4" gutterBottom>
          {update ? "Edit News" : "Create News"}
        </Typography>

        {/* Input Fields */}
        <TextField fullWidth label="Title" value={title} onChange={(e) => setTitle(e.target.value)} margin="normal" required />
        <TextField fullWidth label="Type" value={type} onChange={(e) => setType(e.target.value)} margin="normal" required />
        <TextField fullWidth label="Week" value={week} onChange={(e) => setWeek(e.target.value)} margin="normal" required />
        <TextField fullWidth label="Date" value={date} onChange={(e) => setDate(e.target.value)} margin="normal" required />
        <TextField fullWidth label="Field" value={field} onChange={(e) => setField(e.target.value)} margin="normal" required />
        <TextField fullWidth label="Image URL" value={imageURL} onChange={(e) => setImageURL(e.target.value)} margin="normal" required />
        {imageURL && <img src={imageURL} width={"200px"} height={"100px"} alt="preview" />}

        <TextField
          fullWidth
          label="Short Description"
          value={shortDescription}
          onChange={(e) => setShortDescription(e.target.value)}
          margin="normal"
          multiline
          rows={3}
          required
          inputProps={{ maxLength: 250 }}
          helperText={`${shortDescription.length}/250 characters`}
        />

        {/* Sections */}
        {sections.map((section, index) => (
          <Box
            key={index}
            sx={{
              p: 2,
              border: "1px solid #D3D3D3",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              label="Section Header"
              value={section.header}
              onChange={(e) => handleSectionChange(index, "header", e.target.value)}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Section Content"
              value={section.content}
              onChange={(e) => handleSectionChange(index, "content", e.target.value)}
              margin="normal"
              multiline
              rows={4}
              required
            />
            <Button variant="outlined" color="error" onClick={() => removeSection(index)} sx={{ mt: 2 }}>
              Remove Section
            </Button>
          </Box>
        ))}

        <Button variant="contained" onClick={addSection} sx={{ mt: 3 }}>
          Add Header and Description
        </Button>

        <Button variant="contained" color="secondary" onClick={handleSubmit} sx={{ mt: 3, mb: 3 }}>
          {update ? "Update" : "Publish"}
        </Button>

        {/* Preview */}
        <Typography variant="h6" gutterBottom color="#3a96d7">
          Preview
        </Typography>
        <Paper sx={{ p: 2, m: 2 }}>
          <BlogDetails preview={{ title, author: field, longDescription: addLongDescription(), imageURL }} />
        </Paper>
      </Container>
    </AdminLayout>
  );
};

export default CreateNews;
